import { __awaiter } from "tslib";
export const fetchWrapper = (options) => (...args) => __awaiter(void 0, void 0, void 0, function* () {
    if ((options === null || options === void 0 ? void 0 : options.headers) === undefined) {
        return fetch(...args);
    }
    const [resource, config] = args;
    const enhancedConfig = Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign({}, config === null || config === void 0 ? void 0 : config.headers), options.headers) });
    const response = yield fetch(resource, enhancedConfig);
    return response;
});
